import {
  Link,
  MessageBar,
  MessageBarBody,
  MessageBarTitle,
} from "@fluentui/react-components";
import { Trans, useTranslation } from "react-i18next";
import { useGetCurrentPublishedActivity } from "../../hooks/useActivities";
import { ClientRoutes } from "../../models/ClientRoutes";

interface MirroredActivityMessageBarProps {
  activityId: string;
}

export const MirroredActivityMessageBar = (
  props: MirroredActivityMessageBarProps
) => {
  const { activityId } = props;
  const {
    data: currentVersion,
    isLoading: loadingCurrentVersion,
    isRefetching: refetchingCurrentVersion,
  } = useGetCurrentPublishedActivity(activityId);

  const { t } = useTranslation();

  if (loadingCurrentVersion || refetchingCurrentVersion || !currentVersion) {
    return <></>;
  }

  return (
    <MessageBar intent="warning">
      <MessageBarBody>
        <MessageBarTitle>{t("note")}</MessageBarTitle>
        <Trans
          i18nKey="mirroredActivityWarningMessage"
          components={{
            Link: (
              <Link
                href={`${ClientRoutes.ActivitiesPublished}/${currentVersion.versionId}`}
                target="_blank"
                rel="noopener noreferrer"
              />
            ),
          }}
        />
      </MessageBarBody>
    </MessageBar>
  );
};
